import { ColorScheme } from '@webapp/common/lib/ui';

import { Layout } from '@webapp/landing/src/components/layout';

import NotFoundPage from '@webapp/ui/lib/not-found-page';

export const NotFound: FC = () => (
    <Layout mode={ColorScheme.DARK}>
        <NotFoundPage />
    </Layout>
);
